import { MesfModal } from "@dexteel/mesf-core";
import { Grid, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { FooterModalButtons } from "../../../../../controls/buttons/FooterModalButtons";
import { useDataEntryContext } from "../../context/reducer.provider";
import { useTorchesDataEntryActions } from "../../hooks/useTorchesDataEntryActions";
import { ReadyToCastHeat } from "../../models/catalogs.models";
import { getHeatsForSelector } from "../../repositories/torches.repositories";
type Props = {
  show: boolean;
  onHide: (arrive: boolean) => void;
};
export const HeatSelector = ({ show, onHide }: Props) => {
  const {
    state: { heats, deProcess },
    actions: { setHeats, setHeatSelected, setErrorMessage, setIsDataLoading },
  } = useDataEntryContext();
  const { changeHeatStatus, loadData, refreshData } =
    useTorchesDataEntryActions();
  const { handleSubmit, control } = useForm<ReadyToCastHeat>({});
  const onSubmit: SubmitHandler<any> = async (data: any) => {
    setHeatSelected(data);
    onHide(true);
    const response = await changeHeatStatus(data?.HeatId!, "C");
  };
  const getHeats = useCallback(async () => {
    setIsDataLoading(true);
    const resp = await getHeatsForSelector();
    if (resp.ok) {
      const materials: ReadyToCastHeat[] = resp.data ?? [];
      setHeats(materials);
    } else {
      setErrorMessage(resp.message!);
    }
    setIsDataLoading(false);
  }, [deProcess?.process?.ProcessId]);
  useEffect(() => {
    if (show) {
      getHeats();
    }
  }, [show]);
  return (
    <>
      <MesfModal
        title="SELECT HEAT"
        open={show}
        handleClose={() => onHide(false)}
        id="select-heat-modal"
        maxWidth="sm"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <MesfModal.Content dividers style={{ padding: "15px 30px" }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <Controller
                  name="HeatId"
                  control={control}
                  rules={{ required: "Heat is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <Autocomplete
                      id="clear-on-escape"
                      clearOnEscape
                      options={heats ?? []}
                      getOptionLabel={(option) => option.HeatName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Heat"
                          variant="outlined"
                          fullWidth
                          error={!!error}
                          size="small"
                          helperText={error ? error.message : null}
                        />
                      )}
                      value={
                        heats.find((heat) => heat.HeatId === field.value) ||
                        null
                      }
                      onChange={(event, newValue) => {
                        field.onChange(newValue ? newValue.HeatId : null);
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </MesfModal.Content>
          <MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
            <FooterModalButtons isSubmitLoading={false} onHide={onHide} />
          </MesfModal.Actions>
        </form>
      </MesfModal>
    </>
  );
};
